<div class="gw-space-y-6">
  <div class="gw-flex gw-flex-wrap gw-items-start gw-justify-between gw-gap-4">
    <div class="gw-space-y-2 gw-max-w-3xl">
      <h3 class="gw-text-base gw-font-semibold gw-text-text-primary gw-m-0">
        {{ 'features.feePlans.recipientFees.sectionTitle' | translate }}
      </h3>
      <p class="gw-text-sm gw-text-text-secondary gw-m-0 gw-leading-relaxed">
        {{ 'features.feePlans.recipientFees.intro' | translate }}
      </p>
    </div>
    <div
      *ngIf="!loading && effectivePlan"
      class="gw-flex gw-flex-wrap gw-items-center gw-gap-2 gw-shrink-0"
    >
      <gatewee-button
        *ngIf="planSelectItems.length"
        variant="primary"
        size="m"
        iconName="@tui.pencil"
        [title]="'features.feePlans.recipientFees.changeAssignment' | translate"
        (clicked)="openChangePanel()"
      ></gatewee-button>
      <gatewee-button
        *ngIf="source === 'assignment'"
        variant="outline"
        size="m"
        iconName="@tui.user-minus"
        [title]="'features.feePlans.recipientFees.removeAssignment' | translate"
        (clicked)="requestRemoveAssignment()"
      ></gatewee-button>
    </div>
  </div>

  <div *ngIf="loading" class="gw-text-sm gw-text-text-secondary gw-py-8">
    {{ 'common.loading' | translate }}...
  </div>

  <div
    *ngIf="!loading && effectivePlan"
    class="gw-bg-background-elevation-3 gw-border-base gw-rounded-2xl gw-p-medium gw-space-y-4"
  >
    <div
      class="gw-flex gw-flex-wrap gw-items-center gw-justify-between gw-gap-3"
    >
      <div class="gw-flex gw-flex-wrap gw-items-center gw-gap-3">
        <span class="gw-text-base gw-font-semibold gw-text-text-primary">
          {{
            currentPlan?.name ||
              ('features.feePlans.assignment.source.none' | translate)
          }}
        </span>
        <span
          *ngIf="currentPlan"
          class="gw-inline-flex gw-items-center gw-px-2.5 gw-py-0.5 gw-rounded-full gw-text-xs gw-font-medium gw-bg-background-elevation-2 gw-text-text-secondary"
        >
          ID {{ currentPlan.id }}
        </span>
      </div>
      <div class="gw-flex gw-flex-wrap gw-items-center gw-gap-2">
        <span
          *ngIf="source"
          class="gw-inline-flex gw-items-center gw-px-2.5 gw-py-0.5 gw-rounded-full gw-text-xs gw-font-medium"
          [ngClass]="{
            'gw-bg-background-accent-1 gw-text-text-primary-on-accent-1':
              source === 'assignment',
            'gw-bg-status-positive-pale gw-text-status-positive':
              source === 'default',
            'gw-bg-background-elevation-2 gw-text-text-secondary':
              source === 'none'
          }"
        >
          {{ sourceLabelKey() | translate }}
        </span>
        <span
          *ngIf="currentPlan"
          class="gw-inline-flex gw-items-center gw-px-2.5 gw-py-0.5 gw-rounded-full gw-text-xs gw-font-medium"
          [ngClass]="{
            'gw-bg-status-positive-pale gw-text-status-positive':
              currentPlan.status === 'active',
            'gw-bg-background-elevation-2 gw-text-text-secondary':
              currentPlan.status === 'archived'
          }"
        >
          {{ 'features.feePlans.status.' + currentPlan.status | translate }}
        </span>
      </div>
    </div>

    <div
      *ngIf="currentPlan"
      class="gw-grid gw-grid-cols-1 md:gw-grid-cols-3 gw-gap-2 gw-rounded-xl gw-bg-background-elevation-2 gw-p-3"
    >
      <div class="gw-space-y-1">
        <p class="gw-m-0 gw-text-xs gw-text-text-secondary">Regras</p>
        <p class="gw-m-0 gw-text-sm gw-font-semibold gw-text-text-primary">
          {{ currentPlanRulesCount }}
        </p>
      </div>
      <div class="gw-space-y-1">
        <p class="gw-m-0 gw-text-xs gw-text-text-secondary">Faixas</p>
        <p class="gw-m-0 gw-text-sm gw-font-semibold gw-text-text-primary">
          {{ currentPlanTiersCount }}
        </p>
      </div>
      <div class="gw-space-y-1">
        <p class="gw-m-0 gw-text-xs gw-text-text-secondary">Origem</p>
        <p class="gw-m-0 gw-text-sm gw-font-semibold gw-text-text-primary">
          {{ sourceLabelKey() | translate }}
        </p>
      </div>
    </div>

    <p
      *ngIf="source === 'none' || !currentPlan"
      class="gw-text-sm gw-text-text-secondary gw-m-0"
    >
      {{ 'features.feePlans.recipientFees.noneHint' | translate }}
    </p>

    <div
      *ngIf="currentPlan?.rules?.length"
      class="gw-border-t gw-border-border-normal gw-pt-4 gw-space-y-4"
    >
      <h4 class="gw-text-sm gw-font-semibold gw-text-text-primary gw-m-0">
        {{ 'features.feePlans.view.rules' | translate }}
      </h4>
      <div
        *ngFor="let rule of currentPlan!.rules; let ri = index"
        class="gw-border gw-border-border-normal gw-rounded-xl gw-p-4"
      >
        <p class="gw-text-sm gw-font-medium gw-text-text-primary gw-mb-3">
          {{ 'features.feePlans.form.rule' | translate }} {{ ri + 1 }}:
          <span class="gw-font-normal gw-text-text-secondary">{{
            ruleLabel(rule)
          }}</span>
        </p>
        <p
          *ngIf="!rule.tiers.length"
          class="gw-text-xs gw-text-text-secondary gw-m-0"
        >
          {{ 'features.feePlans.view.noTiers' | translate }}
        </p>
        <div *ngIf="rule.tiers.length" class="gw-overflow-x-auto">
          <table class="gw-w-full gw-text-xs gw-text-text-primary">
            <thead>
              <tr
                class="gw-text-left gw-text-text-secondary gw-border-b gw-border-border-normal"
              >
                <th class="gw-pb-2 gw-pr-4">
                  {{ 'features.feePlans.form.minAmount' | translate }}
                </th>
                <th class="gw-pb-2 gw-pr-4">
                  {{ 'features.feePlans.form.maxAmount' | translate }}
                </th>
                <th class="gw-pb-2 gw-pr-4">
                  {{ 'features.feePlans.form.fixedAmount' | translate }}
                </th>
                <th class="gw-pb-2 gw-pr-4">
                  {{ 'features.feePlans.form.rateValue' | translate }}
                </th>
                <th class="gw-pb-2">
                  {{ 'features.feePlans.form.preview' | translate }} (R$500)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let tier of rule.tiers; trackBy: trackByTier"
                class="gw-border-b gw-border-border-normal/50 last:gw-border-0"
              >
                <td
                  class="gw-py-1.5 gw-pr-4 gw-tabular-nums gw-whitespace-nowrap"
                >
                  {{ formatCurrencyOrDash(tier.minAmount) }}
                </td>
                <td
                  class="gw-py-1.5 gw-pr-4 gw-tabular-nums gw-whitespace-nowrap"
                >
                  <span *ngIf="tier.maxAmount !== null; else unlimitedAmount">
                    {{ formatCurrencyOrDash(tier.maxAmount) }}
                  </span>
                  <ng-template #unlimitedAmount>
                    <span class="gw-text-text-secondary gw-italic">
                      {{
                        'features.feePlans.form.maxAmountUnlimited' | translate
                      }}
                    </span>
                  </ng-template>
                </td>
                <td
                  class="gw-py-1.5 gw-pr-4 gw-tabular-nums gw-whitespace-nowrap"
                >
                  {{ formatCurrencyOrDash(tier.fixedAmount) }}
                </td>
                <td
                  class="gw-py-1.5 gw-pr-4 gw-tabular-nums gw-whitespace-nowrap"
                >
                  {{ formatRateOrDash(tier.rateValue) }}
                </td>
                <td
                  class="gw-py-1.5 gw-font-medium gw-text-primary-brand-background gw-tabular-nums gw-whitespace-nowrap"
                >
                  {{ getTierPreview(tier) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="!loading && !effectivePlan"
    class="gw-text-center gw-py-8 gw-text-sm gw-text-text-secondary"
  >
    {{ 'common.errorLoadingData' | translate }}
  </div>
</div>

<ng-template #changePlanDialog let-close>
  <div class="gw-p-6 gw-space-y-5" [formGroup]="assignForm">
    <div class="gw-space-y-1">
      <h4 class="gw-text-lg gw-font-semibold gw-m-0 gw-text-text-primary">
        {{ 'features.feePlans.recipientFees.changeAssignment' | translate }}
      </h4>
      <p class="gw-m-0 gw-text-xs gw-text-text-secondary">
        Selecione um plano para substituir o atual.
      </p>
    </div>

    <gatewee-select-v3
      formControlName="planId"
      [label]="'features.feePlans.recipientFees.selectPlanLabel' | translate"
      [placeholder]="
        'features.feePlans.recipientFees.selectPlanPlaceholder' | translate
      "
      [items]="planSelectItems"
    ></gatewee-select-v3>

    <div
      *ngIf="selectedPlanSummary"
      class="gw-rounded-lg gw-border gw-border-border-normal gw-bg-background-elevation-2 gw-p-3"
    >
      <p class="gw-m-0 gw-text-xs gw-font-semibold gw-text-text-primary">
        Resumo rapido
      </p>
      <div class="gw-mt-2 gw-grid gw-grid-cols-2 gw-gap-2">
        <p class="gw-m-0 gw-text-xs gw-text-text-secondary">Status</p>
        <p class="gw-m-0 gw-text-xs gw-text-text-primary gw-text-right">
          {{ selectedPlanStatusLabel }}
        </p>
        <p class="gw-m-0 gw-text-xs gw-text-text-secondary">Regras</p>
        <p class="gw-m-0 gw-text-xs gw-text-text-primary gw-text-right">
          {{ selectedPlanRulesCount }}
        </p>
        <p class="gw-m-0 gw-text-xs gw-text-text-secondary">Faixas</p>
        <p class="gw-m-0 gw-text-xs gw-text-text-primary gw-text-right">
          {{ selectedPlanTiersCount }}
        </p>
      </div>
      <p class="gw-m-0 gw-mt-2 gw-text-xs gw-text-text-secondary">
        Metodos: {{ selectedPlanMethodsSummary }}
      </p>
      <p class="gw-m-0 gw-mt-1 gw-text-xs gw-text-text-secondary">
        Operacoes: {{ selectedPlanOperationsSummary }}
      </p>
    </div>

    <div
      *ngIf="assignForm.get('planId')?.value && !hasChangesToAssign"
      class="gw-rounded-lg gw-border gw-border-status-warning gw-bg-status-warning-pale gw-p-3"
    >
      <p class="gw-m-0 gw-text-xs gw-text-text-primary">
        O plano selecionado ja esta atribuido ao dominio.
      </p>
    </div>

    <div class="gw-flex gw-flex-wrap gw-gap-2 gw-justify-end">
      <gatewee-button
        variant="outline"
        size="m"
        [title]="'features.feePlans.recipientFees.cancelChange' | translate"
        (clicked)="cancelChange(close)"
      ></gatewee-button>
      <gatewee-button
        variant="primary"
        size="m"
        [title]="'features.feePlans.recipientFees.confirmAssign' | translate"
        [disabled]="!hasChangesToAssign"
        (clicked)="confirmAssign(close)"
      ></gatewee-button>
    </div>
  </div>
</ng-template>
